import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { UserProvider, useUser } from "./Context/UserContext";
import WelcomePage from "./Pages/WelcomePage/WelcomePage.js";
import LoginPage from "./Pages/LoginPage/LoginPage.js";
import ForgotPasswordPage from "./Pages/ForgotPasswordPage/ForgotPasswordPage.js";
import VerifyCode from "./Pages/VerifyCode/VerifyCode.js";
import NewPassword from "./Pages/NewPassword/NewPassword.js";
import SuccessPage from "./Pages/SuccessPage/SuccessPage";
import JoinCreatorForm from "./Pages/JoinCreatorForm/JoinCreatorForm";
import Dashboard from "./Pages/Dashboard/Dashboard";
import ContentLibrary from "./Pages/ContentLibrary/ContentLibrary";
import UploadVideo from "./Pages/UploadVideo/UploadVideo";
import UploadReel from "./Pages/UploadReel/UploadReel";
import UploadStory from "./Pages/UploadStory/UploadStory";
import ContentAwaitingApproval from "./Pages/ContentAwaitingApproval/ContentAwaitingApproval";
import ScheduledContent from "./Pages/ScheduledContent/ScheduledContent";
import VideoInsights from "./Pages/VideoInsights/VideoInsights";
import ContentAnalytics from "./Pages/ContentAnalytics/ContentAnalytics";
import ContentPage from "./Pages/ContentPage/ContentPage.jsx";
import ProfileEdit from "./Pages/ProfileEdit/ProfileEdit.jsx";
import CommentModeration from "./Pages/CommentModeration/CommentModeration.jsx";
import NotificationPage from "./Pages/NotificationPage/NotificationPage.jsx";
import Subscribers from "./Pages/Subscribers/Subscribers.js";
import VideoReferenceEditor from "./Pages/VideoReferenceEditor/VideoReferenceEditor.jsx";
import PrivacyPolicy from "./Pages/Terms/privacy-policy.js";
import TermsAndCondition from "./Pages/Terms/terms-condition.js";
import ProtectedRoute from "./Routes/ProtectedRoute";

function App() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <UserProvider>
      <Toaster position="top-right" toastOptions={{ duration: 2000 }} />
      <Router>
        <Routes>
          <Route path="/" element={<WelcomePage />} />
          <Route path="/join-creator" element={<JoinCreatorForm />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/verify-code" element={<VerifyCode />} />
          <Route path="/create-new-password" element={<NewPassword />} />
          <Route path="/success-page" element={<SuccessPage />} />
          {/* <Route path="/dashboard" element={<Dashboard />} /> */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/content"
            element={
              <ProtectedRoute>
                <ContentLibrary />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload-video"
            element={
              <ProtectedRoute>
                <UploadVideo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload-reel"
            element={
              <ProtectedRoute>
                <UploadReel />
              </ProtectedRoute>
            }
          />
          <Route
            path="/upload-story"
            element={
              <ProtectedRoute>
                <UploadStory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/view-awaiting-list"
            element={
              <ProtectedRoute>
                <ContentAwaitingApproval />
              </ProtectedRoute>
            }
          />
          <Route
            path="/scheduled-content"
            element={
              <ProtectedRoute>
                <ScheduledContent />
              </ProtectedRoute>
            }
          />
          <Route
            path="/video-insights"
            element={
              <ProtectedRoute>
                <VideoInsights />
              </ProtectedRoute>
            }
          />
          <Route
            path="/content-analytics"
            element={
              <ProtectedRoute>
                <ContentAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/earnings"
            element={
              <ProtectedRoute>
                <ContentAnalytics />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ContentPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/profile-edit"
            element={
              <ProtectedRoute>
                <ProfileEdit />
              </ProtectedRoute>
            }
          />
          <Route
            path="/comment-moderation"
            element={
              <ProtectedRoute>
                <CommentModeration />
              </ProtectedRoute>
            }
          />
          <Route
            path="/notifications"
            element={
              <ProtectedRoute>
                <NotificationPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/subscribers"
            element={
              <ProtectedRoute>
                <Subscribers />
              </ProtectedRoute>
            }
          />
          <Route
            path="/video-reference-editor"
            element={
              <ProtectedRoute>
                <VideoReferenceEditor />
              </ProtectedRoute>
            }
          />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-conditions" element={<TermsAndCondition />} />
        </Routes>
      </Router>
    </UserProvider>
  );
}

export default App;
